<button
  [ngClass]="{
    disabled: !enabled,
    right: right,
    common: color === 'common',
    primary: color === 'primary',
    warning: color === 'warning',
    full: widthFull,
  }"
  [disabled]="!enabled"
  (click)="handleButtonClick($event)"
>
  <div
    *ngIf="loading"
    [ngClass]="{
      label: label,
      common: color === 'common',
      primary: color === 'primary'
    }"
    class="loading-animation"
  ></div>
  <div *ngIf="icon" class="icon">
    <img *ngIf="!loading && icon" [src]="icon" />
  </div>
  <span *ngIf="label">{{ label }}</span>
</button>
